import { Button, buttonVariants } from '@/components/Button';
import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
export const columnsConfig = ({
  companyMemberDetails,
  openProcessModal,
  approveLoading,
  rejectLoading,
}) => {
  return [
    {
      id: 'id',
      name: 'ID',
      sortable: false,
      cellRenderer: (row, rowIndex) => {
        return <div>{rowIndex + 1}</div>;
      },
    },
    {
      id: 'comment',
      name: 'Comment',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {row?.comment}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'type',
      name: 'Type',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {row?.type}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'leaveDate',
      name: 'Leave Date',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {row?.leaveDate}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'requestDate',
      name: 'Request Date',
      sortable: false,
      cellRenderer: (row) => {
        const dateObject = row?.requestDate?.toDate?.();
        if (!dateObject) return '';
        let day = dateObject.getDate();
        let month = dateObject.getMonth() + 1;
        const year = dateObject.getFullYear();
        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >{`${day}-${month}-${year}`}</Text>
          </div>
        );
      },
    },
    {
      id: 'reporter',
      name: 'Reporter',
      sortable: false,
      cellRenderer: (row) => {
        const m = companyMemberDetails[row?.userId];
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {m?.userName || m?.userEmailid || row?.userId || ''}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'departmentId',
      name: 'Department ID',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {row?.teamId}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'status',
      name: 'Status',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {row?.status}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'action',
      name: 'Action',
      sortable: false,
      cellRenderer: (row) => {
        if (row?.status === 'Approved' || row?.status === 'Rejected') {
          return (
            <span className="text-muted">
              <Text
                variant={textVariantsEnum.Text_sm}
                fontWeight={fontWeightEnum.Medium}
              >
                Completed
              </Text>
            </span>
          );
        }
        if (row?.status === 'Pending') {
          return (
            <Button
              variant={buttonVariants.primary_rounded}
              size="sm"
              text="Process"
              onClick={() => openProcessModal(row)}
              disabled={approveLoading || rejectLoading}
            />
          );
        }
        return null;
      },
    },
  ];
};
